import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  gap: 1rem;
  text-align: center;
`;

const Icon = styled.div`
  font-size: 3rem;
  width: 72px;
  height: 72px;
  background: ${({ theme }) => theme.colors.errorLight};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Title = styled.h3`
  color: ${({ theme }) => theme.colors.errorText};
  font-size: 1.1rem;
  font-weight: 600;
`;

const Message = styled.p`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 0.9rem;
  max-width: 400px;
`;

const RetryButton = styled.button`
  padding: 0.6rem 1.5rem;
  background: ${({ theme }) => theme.colors.primary};
  color: white;
  border-radius: ${({ theme }) => theme.radii.md};
  font-weight: 500;
  font-size: 0.9rem;
  transition: background 0.2s;

  &:hover {
    background: ${({ theme }) => theme.colors.primaryHover};
  }
`;

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, onRetry }) => (
  <Wrapper>
    <Icon>⚠️</Icon>
    <Title>Something went wrong</Title>
    <Message>{message}</Message>
    {onRetry && <RetryButton onClick={onRetry}>Try Again</RetryButton>}
  </Wrapper>
);

export default ErrorMessage;
